import { useEffect, useRef } from 'react'

export function useCaptureEventOutsideElement(eventName, handler, deps = []) {
  const ref = useRef()
  useEffect(() => {
    const handleEvent = (e) => {
      if (!ref.current || !e.target) return
      const refIsUnmounted = !document.contains(e.target)
      const clickedOutside = !ref.current.contains(e.target)
      if (!refIsUnmounted && clickedOutside) handler(e)
    }
    document.addEventListener(eventName, handleEvent)
    return () => {
      document.removeEventListener(eventName, handleEvent)
    }
  }, [...deps, handler])
  return ref
}
